import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TokenStorageService } from "src/app/core/auth/token-storage.service";
import { ApiCallService } from "src/app/core/services/api-call-service";
import { ChallengesMilestoneDataService } from "src/app/core/services/challenges-milestone-data.service";
import { Globals } from "src/app/core/services/global.service";
import { SnackbarCollection } from "src/app/core/services/snackbar.service";
import { ChallengeData, nodeDataChallenge } from "src/app/shared/models/model";

interface definitionChallenge {
  name: string | null;
  aliasName: string | null;
  heading: string | null;
  image: string | null;
  description: string | null;
  aliasDescription: string | null;
  conditionGroups: any;
  rewards: any;
}

@Component({
  selector: "app-setting-up-new-milestone-config",
  templateUrl: "./setting-up-new-milestone-config.component.html",
  styleUrls: ["./setting-up-new-milestone-config.component.css"],
})
export class SettingUpNewMilestoneConfigComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiCall: ApiCallService,
    private tokenStorage: TokenStorageService,
    private snackBar: SnackbarCollection,
    private global: Globals,
    private datePipe: DatePipe,
    private challengesMilestoneDataService: ChallengesMilestoneDataService
  ) {}
  step = 1;
  completedSteps = 0;
  type = "MILESTONECONFIG";
  challengeId;
  nodeId;
  status;

  milestoneData = {
    id: null,
    type: this.type,
    configData: {
      milestone: {},
      reward: {},
    },
  };
  isEdit: boolean = false;
  previousNodeId;

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params["type"] === "REWARD") {
        this.type = "REWARDCONFIG";
        this.step = 2;
        this.milestoneData.configData.milestone = null;
        this.milestoneData.type = this.type;
      }
      if (params["steps"]) {
        this.completedSteps = params["steps"];
      }
      if (params["action"] === "edit") {
        this.isEdit = true;
        this.nodeId = params["nodeId"];
        this.challengeId = params["challengeId"];
        if (this.challengesMilestoneDataService.getSingleMilestoneConfig()) {
          this.milestoneData =
            this.challengesMilestoneDataService.getSingleMilestoneConfig();
        }
      }
      if (params["nodeId"]) {
        this.nodeId = params["nodeId"];
      }
      if (params["status"]) {
        this.status = params["status"];
      }
      if (params["challengeId"]) {
        this.challengeId = params["challengeId"];
        if (!this.challengesMilestoneDataService.getChallengeDetails()) {
          this.getChallengeDetailsApi(this.challengeId).then((res) => {
            this.challengesMilestoneDataService.setChallengeDetails(
              res["body"]
            );
            let data: any = res["body"];
            data.scheduledStartTime = this.formatTimestamp(data["executionDate"], 'start');
            data.scheduledEndTime = this.formatTimestamp(data["scheduleEndDate"], 'end');
            this.challengesMilestoneDataService.setChallengeDetails(data);
            let milestoneConfig = this.global.safeParse(
              res["body"]["displayParams"]
            );
            this.challengesMilestoneDataService.setMilestoneConfig(
              milestoneConfig
            );

            this.milestoneData = this.getMilestoneById(
              this.nodeId,
              milestoneConfig
            );
            console.log(this.milestoneData);
            this.challengesMilestoneDataService.setSingleMilestoneConfig(
              this.milestoneData
            );
          });
        }
      }
      if (params["previousNodeId"]) {
        this.previousNodeId = params["previousNodeId"];
      }
    });
  }

  getMilestoneById(id, data) {
    if (!Array.isArray(data)) {
      return null;
    }
    return data.find((item) => item.id == id);
  }

  async milestoneConfig(value) {
    console.log(value);
    if (value.isGoBack) {
      if(!this.previousNodeId){
        this.router.navigate(["app/challenges/create-new"], {
          queryParams: {
            action: "new",
            id: this.challengeId,
          },
        });
      } else{
        this.router.navigate(["/app/challenges/view-challenge"], {
          queryParams: {
            challengeId: this.challengeId,
          },
        });
      }
      return
    }
    let definition: definitionChallenge;

    if (this.type === "REWARDCONFIG") {
      definition = {
        name: value?.configData?.["name"] ?? "Reward",
        aliasName: value?.configData?.aliasName ?? "",
        description: value?.configData?.["description"] ?? "",
        aliasDescription: value?.configData?.aliasDescription ?? "",
        heading: value?.configData?.["heading"] ?? "",
        image: value?.configData?.["image"] ?? "",
        conditionGroups:
          this.milestoneData?.configData?.milestone?.["milestoneconfigApi"] ??
          null,
        rewards:
          this.global.extractRewardDetails(
            this.milestoneData?.configData?.reward?.["rewardData"]
          ) ?? null,
      };
    } else {
      definition = {
        name:
          (value?.configData?.["name"] ||
            this.milestoneData.configData.milestone["name"]) ??
          "",
        aliasName:
          (value?.configData?.aliasName ||
            this.milestoneData.configData.milestone["aliasName"]) ??
          "",
        description:
          (value?.configData?.["description"] ||
            this.milestoneData.configData.milestone["description"]) ??
          "",
        aliasDescription:
          (value?.configData?.aliasDescription ||
            this.milestoneData.configData.milestone["aliasDescription"]) ??
          "",
        heading:
          (value?.configData?.["heading"] ||
            this.milestoneData.configData.milestone["heading"]) ??
          "",
        image: (value?.configData?.["image"] || this.milestoneData.configData.milestone["image"])?? "",
        conditionGroups: this.milestoneData?.configData?.milestone?.["milestoneconfigApi"] ?? null, // Different data
        rewards:
          this.global.extractRewardDetails(
            this.milestoneData?.configData?.reward?.["rewardData"]
          ) ?? null,
      };
    }

    if (value.nextView === "reward") {
      this.milestoneData.configData.milestone = value.configData;
      definition.conditionGroups = value.configData.milestoneconfigApi;
      this.challengesMilestoneDataService.setSingleMilestoneConfig(
        this.milestoneData
      );
      await this.checkIfEditAndUpdateValue(
        definition,
        value.nextView,
        value.isExit
      );
    }
    if (value.nextView === "summary") {
      this.milestoneData.configData.reward["rewardData"] =
        value.configData.rewardData;
      definition.rewards = this.global.extractRewardDetails(
        value.configData.rewardData
      );
      this.challengesMilestoneDataService.setSingleMilestoneConfig(
        this.milestoneData
      );
      await this.checkIfEditAndUpdateValue(
        definition,
        value.nextView,
        value.isEdit
      );
    }
  }

  async checkIfEditAndUpdateValue(
    definition: definitionChallenge,
    view,
    isExit
  ): Promise<void> {
    let challengeData: ChallengeData =
      this.challengesMilestoneDataService.getChallengeDetails();

    let nodeDataFormat: nodeDataChallenge = {
      id: this.nodeId ? this.nodeId : null,
      challengeId: this.challengeId ? this.challengeId : null,
      merchantId: this.tokenStorage.getMerchantId(),
      previousNodeId: this.previousNodeId ? this.previousNodeId : null,
      previousNodeRelation: this.previousNodeId ? "NEXT" : "",
      nodeType:
        this.type === "MILESTONECONFIG" ? "CHALLENGE_MILESTONE_NODE" : "REWARD",
      definition: JSON.stringify(definition),
    };
    if (!this.isEdit) {
      if (!this.nodeId) {
        this.createNodeApi(nodeDataFormat).then(
          (result) => {
            if (result) {
              this.nodeId = result["body"];
              this.router.navigate([], {
                relativeTo: this.route,
                queryParams: { nodeId: this.nodeId, action: "edit" },
                queryParamsHandling: "merge",
              });
              this.updatingData(challengeData, result, view, "new", isExit);
            }
          },
          (err) => {
            this.snackBar.openSnackBar(err.message, 2000);
          }
        );
      } else {
        this.updateNodeApi(nodeDataFormat).then(
          (result) => {
            this.updatingData(challengeData, result, view, "update", isExit);
          },
          (err) => {
            this.snackBar.openSnackBar(err.message, 2000);
          }
        );
      }
    } else {
      const updatedData = this.challengesMilestoneDataService
        .getMilestoneConfig()
        .map((item) =>
          item.id === this.nodeId
            ? { ...item, configData: this.milestoneData.configData }
            : item
        );
      this.updateNodeApi(nodeDataFormat).then(
        (result) => {
          this.challengesMilestoneDataService.setMilestoneConfig(updatedData);
          challengeData.totalMilestones = this.getMilestoneCount(updatedData);
          challengeData.displayParams = JSON.stringify(
            this.global.removeMilestoneConfigApi(updatedData)
          );
          // if (view === "summary") {
          //   this.completedSteps++;
          //   this.router.navigate(["/app/challenges/view-challenge"], {
          //     queryParams: {
          //       id: this.challengeId,
          //     },
          //   });
          // } else {
          //   this.step = 2;
          //   this.completedSteps++;
          // }
          this.updateDisplayParamsApi(challengeData).then(
            (res) => {
              if (res) {
                if (isExit) {
                  this.challengesMilestoneDataService.resetAllData();
                  this.router.navigate(["/app/challenges/"]);
                  return;
                }
                if (view === "summary") {
                  this.completedSteps++;
                  this.router.navigate(["/app/challenges/view-challenge"], {
                    queryParams: {
                      challengeId: this.challengeId,
                    },
                  });
                } else {
                  this.step = 2;
                  this.completedSteps++;
                }
              } else {
                this.snackBar.openSnackBar(
                  "Error while saving challenge",
                  2000
                );
              }
            },
            (err) => {
              this.snackBar.openSnackBar(err.message, 2000);
            }
          );
        },
        (err) => {
          this.snackBar.openSnackBar(err.message, 2000);
        }
      );
    }
  }

  getMilestoneCount(data): number {
    if (!data || typeof data !== "object" || Object.keys(data).length === 0) {
      return 0;
    }
    return Array.isArray(data)
      ? data.filter((item) => item.type === "MILESTONECONFIG").length
      : 0;
  }
  changeSteps(step) {
    this.step = step;
  }

  updatingData(challengeData: ChallengeData, result, view, type, isExit) {
    if (
      this.challengesMilestoneDataService.getMilestoneConfig() &&
      type === "new"
    ) {
      let arrayValue = this.challengesMilestoneDataService.getMilestoneConfig();
      this.milestoneData.id = this.nodeId;
      arrayValue.push(this.milestoneData);
      this.challengesMilestoneDataService.setMilestoneConfig(arrayValue);
      challengeData.id = this.challengeId;
      challengeData.totalMilestones = this.getMilestoneCount(arrayValue);
      console.log(arrayValue);

      challengeData.displayParams = JSON.stringify(
        this.global.removeMilestoneConfigApi(arrayValue)
      );
    } else if (
      this.challengesMilestoneDataService.getMilestoneConfig() &&
      type === "update"
    ) {
      const updatedData = this.challengesMilestoneDataService
        .getMilestoneConfig()
        .map((item) =>
          item.id == this.nodeId
            ? { ...item, configData: this.milestoneData.configData }
            : item
        );
      this.challengesMilestoneDataService.setMilestoneConfig(updatedData);
      challengeData.id = this.challengeId;
      challengeData.totalMilestones = this.getMilestoneCount(updatedData);
      console.log(updatedData);
      challengeData.displayParams = JSON.stringify(
        this.global.removeMilestoneConfigApi(updatedData)
      );
    } else {
      this.milestoneData.id = this.nodeId;
      this.challengesMilestoneDataService.setMilestoneConfig([
        this.milestoneData,
      ]);
      challengeData.startNodeId = result["body"];
      challengeData.id = this.challengeId;
      challengeData.totalMilestones = 1;
      console.log(this.milestoneData);
      challengeData.displayParams = JSON.stringify([this.milestoneData]);
    }
    this.updateDisplayParamsApi(challengeData).then(
      (res) => {
        if (res) {
          if (isExit) {
            this.challengesMilestoneDataService.resetAllData();
            this.router.navigate(["/app/challenges/"]);
            return;
          }
          if (view === "summary") {
            this.completedSteps++;
            this.router.navigate(["/app/challenges/view-challenge"], {
              queryParams: {
                challengeId: this.challengeId,
              },
            });
          } else {
            this.step = 2;
            this.completedSteps++;
          }
        } else {
          this.snackBar.openSnackBar("Error while saving the challenge.", 2000);
        }
      },
      (err) => {
        this.snackBar.openSnackBar(err.message, 2000);
      }
    );
  }

  formatTimestamp(timestamp: number, type: 'start' | 'end'): string {
    const merchantTimeZone = this.tokenStorage.getMerchantTimeZone();
  
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: merchantTimeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(timestamp);
  
    const dateParts: any = {};
    parts.forEach((part) => {
      if (part.type !== "literal") {
        dateParts[part.type] = part.value;
      }
    });
  
    const time = type === "start" ? "00:00:00" : "23:59:59";
  
    return `${dateParts.year}-${dateParts.month}-${dateParts.day} ${time}`;
  }
  

  createNodeApi(data: nodeDataChallenge) {
    return new Promise((resolve, reject) => {
      this.apiCall.createChallengeNode(data).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);
          reject(err.error);
        }
      );
    });
  }

  updateNodeApi(data) {
    return new Promise((resolve, reject) => {
      this.apiCall.updateChallengeNode(data, this.nodeId).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);
          reject(err.error);
        }
      );
    });
  }

  updateDisplayParamsApi(data) {
    return new Promise((resolve, reject) => {
      this.apiCall.updateChallenge(data, this.challengeId).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);
          reject(err.error);
        }
      );
    });
  }

  getChallengeDetailsApi(id) {
    return new Promise((resolve, reject) => {
      this.apiCall.getChallengeDetails(id).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);
          reject(err.error);
        }
      );
    });
  }
}
